export { Iconify29 } from "./Iconify29";
